module.exports = __webpack_public_path__ + "static/media/thum2.d0302c61.jpg";